var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentContainer",staticStyle:{"background":"#fff","padding-left":"0","padding-right":"0"}},[_c('GoodsInDatatable',{ref:"purchaseOrderGoodsInDatatable",attrs:{"purchaseOrderNr":_vm.purchaseOrderNr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }